export const greeting = 'Hi, My name is';
export const myName = 'Md MAsrur Alam.';
export const intro =
	'I am a Full Stack Developer . I build things for web.';
